import { handleOpenChat } from "utils/analytics";

export default function About() {
  return (
    <div className="flex items-center flex-col flex-wrap p-5">
      <img src="/logo.png" className="h-40" alt="Peromar" />
      <h3 className="text-center py-5 text-xl">Tenha uma experiência<br/> inesquecível no Caribe Brasileiro</h3>
      <p className="text-center">
        O Beach Point Barra Grande fica a beira mar da Praia de Barra Grande, a mais bela de Maragogi<br/>
      </p>
        <button onClick={handleOpenChat} type="submit" className="text-white bg-emerald-500 py-2 px-5 rounded mt-5">
          Fale Conosco
        </button>
    </div>
  )
}